import React, { useState, useEffect } from "react";
import "./Home.css";
import axios from "axios";
import Sidebar from "./components/Sidebar/Sidebar";
import Rightbar from "./components/Rightbar/Rightbar";
import Feed from "./components/Feed/Feed";
import { Menu, X, Users, Home as HomeIcon, Earth, Bell, CircleUser } from "lucide-react";

export default function Home() {
  const [posts, setPosts] = useState([]);
  const [loadingPosts, setLoadingPosts] = useState(true);
  const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
  const [error, setError] = useState("");
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMobileRightbar, setShowMobileRightbar] = useState(false);
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  
  const fetchPosts = async () => {
    try {
      setLoadingPosts(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/posts`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setPosts(res.data);
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load posts");
    } finally {
      setLoadingPosts(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showMobileMenu && 
          !event.target.closest('.sidebar-wrapper') && 
          !event.target.closest('.mobile-menu-toggle')) {
        setShowMobileMenu(false);
      }
      if (showMobileRightbar && 
          !event.target.closest('.rightbar-wrapper') && 
          !event.target.closest('.mobile-rightbar-toggle')) {
        setShowMobileRightbar(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showMobileMenu, showMobileRightbar]);

  useEffect(() => {
    if (showMobileMenu || showMobileRightbar) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showMobileMenu, showMobileRightbar]);

  const toggleMobileMenu = (e) => {
    e.stopPropagation();
    setShowMobileMenu(!showMobileMenu);
    if (showMobileRightbar) setShowMobileRightbar(false);
  };

  const toggleMobileRightbar = (e) => {
    e.stopPropagation();
    setShowMobileRightbar(!showMobileRightbar);
    if (showMobileMenu) setShowMobileMenu(false);
  };

  const closeAllMobileMenus = () => {
    setShowMobileMenu(false);
    setShowMobileRightbar(false);
  };

  const refreshAll = async () => {
    await fetchPosts();
    setSidebarRefreshKey(prev => prev + 1);
  };

  return (
    <div className="home-container">
      <header className="mobile-header">
        <div className="mobile-header-left">
          <button 
            className="mobile-menu-toggle" 
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {showMobileMenu ? <X size={24} /> : <Menu size={24} />}
          </button>
          <h1 className="mobile-logo">UniCircle</h1>
        </div>
        <button 
          className="mobile-rightbar-toggle"
          onClick={toggleMobileRightbar}
          aria-label="Toggle rightbar"
        >
          <Earth size={20} />
          {!showMobileRightbar && <span className="notification-dot"></span>}
        </button>
      </header>
      {(showMobileMenu || showMobileRightbar) && (
        <div 
          className="mobile-overlay active" 
          onClick={closeAllMobileMenus}
        />
      )}
      <div className="home-layout">
        {/* Sidebar */}
        <div className={`sidebar-wrapper ${showMobileMenu ? 'mobile-visible' : ''}`}>
          <Sidebar refreshKey={sidebarRefreshKey} />
        </div>

        {/* Main Feed */}
        <main className="main-content">
          <Feed
            posts={posts}
            loading={loadingPosts}
            error={error}
            refreshPosts={refreshAll}
          />
        </main>

        {/* Rightbar */}
        <div className={`rightbar-wrapper ${showMobileRightbar ? 'mobile-visible' : ''}`}>
          <Rightbar />
        </div>
      </div>

      {/* Mobile Bottom Navigation */}
      <nav className="mobile-bottom-nav">
        <button className="bottom-nav-item active">
          <HomeIcon size={20} />
          <span>Home</span>
        </button>
        <button className="bottom-nav-item">
          <Users size={20} />
          <span>Network</span>
        </button>
        <button className="bottom-nav-item">
          <Bell size={20} />
          <span>Notifications</span>
          <span className="nav-badge">3</span>
        </button>
        <button className="bottom-nav-item">
          <CircleUser size={20} />
          <span>Profile</span>
        </button>
      </nav>
    </div>
  );
}